import { useQuery } from "@apollo/client";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import { LinearProgress } from "@mui/material";
import { DateTime } from "luxon";
import ReactMarkdown from "react-markdown";
import { useNavigate, useParams } from "react-router-dom";
import remarkGfm from "remark-gfm";
import { gql } from "../../../__generated__";
import styles from "./index.module.scss";

export default function NewsArticle() {
  const navigate = useNavigate();
  const { id = "" } = useParams<{ id: string }>();
  const { data, loading } = useQuery(GET_NEWS_ARTICLE, {
    variables: { id },
    skip: !id,
  });

  if (loading) return <LinearProgress color="error" />;

  const article = data?.newsArticle;
  if (!article?.translation) return <>News article not found.</>;

  return (
    <main className={styles.page}>
      <img className={styles.hero} src={article.imageUrl} alt="" />

      <article className={styles.article}>
        <div className={styles.date}>
          <CalendarTodayOutlinedIcon aria-hidden="true" />
          <time dateTime={article.date}>
            {DateTime.fromISO(article.date).toFormat("LLLL d, yyyy")}
          </time>
        </div>

        <h1>{article.translation.title}</h1>

        <div className={styles.content}>
          <ReactMarkdown remarkPlugins={[remarkGfm]}>
            {article.translation.content}
          </ReactMarkdown>
        </div>

        <footer className={styles.footer}>
          <button
            className={styles.backLink}
            type="button"
            onClick={() => navigate(-1)}
          >
            <ArrowBackIcon aria-hidden="true" />
            Back
          </button>
        </footer>
      </article>
    </main>
  );
}

const GET_NEWS_ARTICLE = gql(`
  query GetNewsArticle($id: ID!) {
    newsArticle(id: $id) {
      id
      date
      imageUrl
      translation(lang: en) {
        title
        content
      }
    }
  }
`);
